import { Helmet } from "react-helmet";

export default function Impressum() {
  return (
    <>
      <Helmet>
        <title>Impressum – Kanzlei Preisner</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div className="mx-auto max-w-4xl px-6 py-12 text-slate-800">
        <h1 className="text-3xl font-semibold mb-6">Impressum</h1>

        <p className="mb-4 font-medium">Rechtsanwalt Thomas M. Preisner</p>

        <p className="mb-4">
          Koloniestraße 21<br />
          13359 Berlin<br />
          Deutschland
        </p>

        <p className="mb-6">
          E-Mail: <a className="underline" href="mailto:info@kanzlei-preisner.de">info@kanzlei-preisner.de</a><br />
          Telefon: <a className="underline" href="tel:+4915901462495">01590-1462495</a><br />
          Website: <a className="underline" href="https://www.kanzlei-preisner.de" target="_blank" rel="noopener noreferrer">www.kanzlei-preisner.de</a>
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">
          Anbieterkennzeichnung gemäß § 5 DDG
        </h2>
        <p className="mb-4">
          Thomas M. Preisner, Rechtsanwalt (Deutschland)<br />
          Einzelkanzlei
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">
          Zuständige Aufsichtsbehörde / Kammer
        </h2>
        <p className="mb-4">
          Rechtsanwaltskammer Berlin<br />
          Littenstraße 9<br />
          10179 Berlin<br />
          <a className="underline" href="https://www.rak-berlin.de" target="_blank" rel="noopener noreferrer">
            www.rak-berlin.de
          </a>
        </p>

        <p className="mb-4">
          Berufsbezeichnung: Rechtsanwalt (verliehen in der Bundesrepublik Deutschland)
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">
          Berufshaftpflichtversicherung gemäß § 51 BRAO
        </h2>
        <p className="mb-4">
          R+V Allgemeine Versicherung AG<br />
          Raiffeisenplatz 1<br />
          65189 Wiesbaden
        </p>
        <p className="mb-4">
          Versicherungssumme: 250.000 € pro Versicherungsfall<br />
          Räumlicher Geltungsbereich: Mitgliedstaaten der Europäischen Union und EWR
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">
          Berufsrechtliche Regelungen
        </h2>
        <ul className="list-disc ml-6 mb-4">
          <li>Bundesrechtsanwaltsordnung (BRAO)</li>
          <li>Berufsordnung für Rechtsanwälte (BORA)</li>
          <li>Rechtsanwaltsvergütungsgesetz (RVG)</li>
          <li>Fachanwaltsordnung (FAO)</li>
          <li>Berufsregeln der Rechtsanwälte der EU (CCBE)</li>
        </ul>
        <p className="mb-4">
          Abrufbar unter:&nbsp;
          <a className="underline" href="https://www.brak.de/fuer-anwaelte/berufsrecht" target="_blank" rel="noopener noreferrer">
            https://www.brak.de/fuer-anwaelte/berufsrecht
          </a>
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">
          Verantwortlich i.S.d. § 18 Abs. 2 MStV
        </h2>
        <p className="mb-6">
          Thomas M. Preisner, Rechtsanwalt<br />
          Koloniestraße 21, 13359 Berlin
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">
          Verbraucherstreitbeilegung (§ 36 VSBG)
        </h2>
        <p className="mb-6">
          Ich bin nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren
          vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">
          Online-Streitbeilegung (Art. 14 ODR-VO)
        </h2>
        <p className="mb-6">
          Plattform der Europäischen Kommission:&nbsp;
          <a className="underline" href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
            https://ec.europa.eu/consumers/odr
          </a>
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">
          Haftungsausschluss
        </h2>
        <p className="mb-4">
          Externe Links: Für Inhalte verlinkter Seiten sind ausschließlich deren Betreiber verantwortlich.
        </p>
        <p className="mb-6">
          Inhalte dieser Website wurden sorgfältig erstellt. Eine Gewähr für Aktualität, Richtigkeit
          und Vollständigkeit wird nicht übernommen.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">Urheberrecht</h2>
        <p className="mb-6">
          Alle Inhalte dieser Website (Texte, Bilder, Logos, Layout) sind urheberrechtlich geschützt.
          Jede Verwertung außerhalb gesetzlicher Ausnahmen bedarf der vorherigen schriftlichen Zustimmung.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">Hinweis zur Mandatsannahme</h2>
        <p>
          Über diese Website werden ausschließlich <strong>B2B-Terminsvertretungen für Anwaltskanzleien</strong> angeboten.
          Es erfolgt <strong>keine Mandatsannahme gegenüber Verbrauchern</strong> (§ 13 BGB).
        </p>
      </div>
    </>
  );
}

